'use strict';

self.addEventListener('push', function (event) {
    console.log('[Service Worker] Push Received.');
    console.log(`[Service Worker] Push had this data: "${event.data.text()}"`);
    var data = {};

    try {
        var data = JSON.parse(event.data.text());
    }
    catch (ex) {
        data.message = event.data.text();
    }

    const title = data.title || 'CoreVision';
    const options = {
        body: data.message || 'Yay it works.',
        icon: `/assets/icons/cv32.png`,
        badge: `/assets/icons/cvbadge.png`
    };

    event.waitUntil(self.registration.showNotification(title, options));
});

self.addEventListener('notificationclick', function (event) {
    console.log('[Service Worker] Notification click Received.');

    event.notification.close();

    event.waitUntil(
        clients.openWindow('http://www.corevision.com.au/')
    );
});



// WEBPACK FOOTER //
// ./sw.js